import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import { HoverTooltip } from 'Components/HoverTooltip/HoverTooltip';
import dayjs from 'dayjs';
import * as advancedFormat from 'dayjs/plugin/advancedFormat';
import { AuthorizedRoutePaths } from 'Interfaces/RoutePaths';
import SuccessPageWrapper from 'Layouts/SuccessPageWrapper';
import { selectUser } from 'Utils/selectors';

import { SecondStepInfo } from './components/SecondStepInfo';
import { Tabs } from './components/Tabs';

import AlertIcon from 'Assets/images/icons/alert-icon.svg';

dayjs.extend(advancedFormat.default);

const TrialGetPage = () => {
  const navigate = useNavigate();

  const { isTrialUsed } = useSelector(selectUser);

  const navigateToRoot = useCallback(() => {
    navigate(AuthorizedRoutePaths.BASE_PATH, { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (isTrialUsed) {
      return navigateToRoot();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigateToRoot]);

  return (
    <SuccessPageWrapper>
      <div className="sign-up-second-step">
        <div className="sign-up-second-step__tabs-wrapper">
          <Tabs activeTab={2} />
        </div>
        <p className="sign-up-second-step__title">
          Please add your payment details to{' '}
          <span className="sign-up-second-step__title-underline">
            start the free trial.
          </span>{' '}
          <br />
          You can cancel anytime before the free trial ends to avoid being billed.
          <span className={`dropDownMenu__alert header__help--stroke`}>
            <ReactSVG src={AlertIcon} className="header__help-icon" />
            <HoverTooltip>
              You won&apos;t be billed anything until the end of your trial period -{' '}
              <b>
                {dayjs(new Date())
                  .add(7, 'day')
                  .format('MMM Do')}
              </b>
              . You can cancel your subscription free of charge any time during the trial
              with just four simple clicks on your <b>billing details</b>.
            </HoverTooltip>
          </span>
        </p>
        <SecondStepInfo />
      </div>
    </SuccessPageWrapper>
  );
};

export default TrialGetPage;
